import { BriefLetter, BriefResume } from 'builder/modules/panel'
import { formatDocumentPreviewUrl } from 'builder/utils/formatDocumentPreviewUrl'
import * as Styled from './styles'

interface IPreviewProps {
  document: BriefResume | BriefLetter
}

export const Preview = (props: IPreviewProps) => {
  const imageSrc = formatDocumentPreviewUrl(props.document, { size: 256 })

  return (
    <Styled.Container>
      <Styled.ImagePreview src={imageSrc} />
    </Styled.Container>
  )
}
